"use client";

import { useState } from "react";

interface Props {
  product: string;
}

export default function ContactForm(props: Props) {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");

  return (
    <section className="flex flex-col gap-4 items-center w-full px-4 py-20 overflow-hidden bg-white">
      <div className="flex flex-col gap-4 w-full">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-center">
            <h2 className="text-black text-3xl font-bold tracking-tight">
              Schreiben Sie uns – wir freuen uns auf Ihre Nachricht!
            </h2>

            <p className="mt-3 text-black">
              Vereinbaren Sie jetzt Ihren Termin für ein persönliches Gespräch
              bei SDI.
            </p>

            <form
              className="mt-8 grid grid-cols-1 gap-3 text-left"
              onSubmit={async (e) => {
                e.preventDefault();
                setStatus("sending");

                const form = e.currentTarget;
                const formData = new FormData(form);
                formData.set("product", props.product);

                try {
                  const response = await fetch("/api/send", {
                    method: "POST",
                    body: formData, // kein JSON mehr, direkt FormData
                  });

                  if (response.ok) {
                    setStatus("success");
                    form.reset();
                  } else {
                    setStatus("error");
                  }
                } catch (error) {
                  console.error(error);
                  setStatus("error");
                }
              }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <label className="block">
                  <span className="text-black text-sm">Name</span>
                  <input
                    name="name"
                    required
                    className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-(--brand-700)"
                    placeholder="Max Mustermann"
                  />
                </label>

                <label className="block">
                  <span className="text-black text-sm">E-Mail</span>
                  <input
                    type="email"
                    name="email"
                    required
                    className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-(--brand-700)"
                    placeholder="max@beispiel.de"
                  />
                </label>
              </div>

              <label className="block">
                <span className="text-black text-sm">Unternehmen</span>
                <input
                  name="unternehmen"
                  className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-(--brand-700)"
                  placeholder="Modehaus Beispiel GmbH"
                />
              </label>

              <label className="block">
                <span className="text-black text-sm">Nachricht (optional)</span>
                <textarea
                  name="nachricht"
                  rows={4}
                  className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-(--brand-700)"
                  placeholder="Ich interessiere mich für …"
                />
              </label>

              {/* NEU: Datei-Upload */}
              <label className="block">
                <span className="text-black text-sm">Anhänge (optional)</span>
                <input
                  type="file"
                  name="attachments"
                  multiple
                  className="mt-1 w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-black focus:outline-none focus:ring-2 focus:ring-(--brand-700)"
                />
              </label>

              <button
                type="submit"
                disabled={status === "sending"}
                className="mt-2 inline-flex w-full sm:w-auto items-center justify-center rounded-full h-12 px-8 text-[15px] font-medium bg-(--brand-700) text-white shadow-sm transition-all duration-200 ease-out hover:bg-brand-primary-dark hover:-translate-y-1 hover:shadow-xl hover:text-white disabled:bg-slate-400"
              >
                {status === "sending" ? "Wird gesendet..." : "Anfrage senden!"}
              </button>

              {status === "success" && (
                <p className="mt-3 text-sm text-green-600 font-medium">
                  ✅ Anfrage erfolgreich versendet!
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 text-sm text-red-600 font-medium">
                  ❌ Fehler beim Senden. Bitte versuchen Sie es erneut.
                </p>
              )}

              <p className="mt-3 text-xs text-black text-center">
                Mit Absenden stimmen Sie unserer Kontaktaufnahme zu. Ihre Daten
                werden vertraulich behandelt.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
